import { isTseuCountry } from './contactSearchAndFormat';
import Config from '../Config';

const config = new Config();

export const findSalesRep = (salesReps, salesRepKey) => salesReps.find(sr => sr.key === salesRepKey);

export const getTssSalesReps = salesReps => salesReps.filter(sr => sr.division === 'TSS');

export const getTseuSalesReps = salesReps => salesReps.filter(sr => sr.division === 'TSEU');

export const filterCountrySalesReps = (salesReps, countryOfResidence, countries) => {
  if (!salesReps || salesReps.length === 0) {
    return [];
  }

  if (
    !config.tseuChangesEnabled ||
    !countryOfResidence ||
    countryOfResidence.length === 0 ||
    !countries ||
    countries.length === 0
  ) {
    return getTssSalesReps(salesReps);
  }

  return isTseuCountry(countries, countryOfResidence) ? getTseuSalesReps(salesReps) : getTssSalesReps(salesReps);
};

export const filterAppSalesReps = (salesReps, application) => {
  if (!salesReps || salesReps.length === 0) {
    return [];
  }

  if (!config.tseuChangesEnabled || !application) {
    return getTssSalesReps(salesReps);
  }

  return application.isTSEU ? getTseuSalesReps(salesReps) : getTssSalesReps(salesReps);
};

export const filterSalesRepFromUrl = (salesReps, urlSalesRep) => {
  if (!salesReps || salesReps.length === 0) return [];

  const salesRep = findSalesRep(salesReps, urlSalesRep);
  return salesRep && salesRep.division === 'TSEU'
    ? getTseuSalesReps(salesReps)
    : getTssSalesReps(salesReps);
};
